module.exports = "<p>other-report works!</p>\r\n"